/* Creatine product page (Lovable design). Native product-form/variant-button do the buying; this file only
   syncs the Lovable flavour cards with the native swatches, adds the native bundle product, and runs gallery/tabs. */
(function () {
  'use strict';
  var root = document.getElementById('clv-main');
  if (!root) return;
  document.documentElement.classList.add('clv-js');
  var ps = root.closest('.product-section');
  var V = []; try { V = JSON.parse(ps.querySelector('[data-variant-json]').value || ps.querySelector('[data-variant-json]').textContent); } catch (e) {}
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function nativeForm() { return ps.querySelector('form[action*="/cart/add"]'); }
  function currentId() { var f = nativeForm(), i = f && f.querySelector('[name="id"]'); return i ? String(i.value) : ''; }
  function syncCards() {
    var id = currentId();
    $$('[data-clv-flavour]').forEach(function (b) { var on = b.getAttribute('data-clv-flavour') === id; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    var v = V.filter(function (x) { return String(x.id) === id; })[0], u = root.querySelector('[data-clv-unit]');
    if (v && u && window.theme && theme.Currency) u.innerHTML = theme.Currency.formatMoney(v.price, theme.settings && theme.settings.moneyFormat);
    else if (v && u) u.textContent = '£' + (v.price / 100).toFixed(2);
    syncImage(v);
    if (v) $$('[data-clv-atc-was]').forEach(function (s) { var ok = v.compare_at_price > v.price; s.hidden = !ok; if (ok) s.textContent = '£' + (v.compare_at_price / 100).toFixed(2); });
    var cs = document.querySelector('#sticky-product-form custom-selection');
    if (v && cs) { cs.setAttribute('active-item-title', v.title); var te = cs.querySelector('.title-element'); if (te) te.textContent = v.title;
      $$('.list-item', cs).forEach(function (li) { li.classList.toggle('list-item-active', li.getAttribute('data-variant-id') === String(v.id)); });
      var vs = document.querySelector('#variant-select'); if (vs) vs.value = String(v.id); }
    var w = root.querySelector('[data-clv-was]'), sv = root.querySelector('[data-clv-save]');
    if (v && w && sv) { var ok = v.compare_at_price > v.price; w.hidden = sv.hidden = !ok; if (ok) { w.textContent = '£' + (v.compare_at_price / 100).toFixed(2); sv.textContent = 'Save £' + ((v.compare_at_price - v.price) / 100).toFixed(2); } }
    syncBuy(v);
  }
  function gbp(c) { return '£' + (c / 100).toFixed(2); }
  function buyMode() { var bb = root.querySelector('[data-clv-buybox]'); return bb ? bb.getAttribute('data-mode') : 'single'; }
  function syncBuy(v) {
    var bb = root.querySelector('[data-clv-buybox]'); if (!bb) return;
    if (!v) { var id = currentId(); v = V.filter(function (x) { return String(x.id) === id; })[0]; }
    var mode = bb.getAttribute('data-mode'), tr = bb.querySelector('input[value="bundle"]');
    $$('.clv-opt', bb).forEach(function (l) { var i = l.querySelector('input'); l.classList.toggle('is-on', i.checked); });
    var price, was, label;
    if (mode === 'bundle' && tr) { price = +tr.getAttribute('data-price'); was = +tr.getAttribute('data-was'); label = 'Add all 3 to Cart'; }
    else if (v) { price = v.price; was = v.compare_at_price || 0; label = v.available ? 'Add to Cart' : 'Sold out'; }
    else return;
    var btn = bb.querySelector('[data-clv-buy]'); btn.disabled = mode !== 'bundle' && v && !v.available;
    bb.querySelector('[data-clv-buy-label]').textContent = label;
    bb.querySelector('[data-clv-buy-price]').textContent = gbp(price);
    var bw = bb.querySelector('[data-clv-buy-was]'); if (bw) { bw.hidden = !(was > price); bw.textContent = gbp(was); }
    if (v) { var op = bb.querySelector('[data-clv-opt-price]'), ow = bb.querySelector('[data-clv-opt-was]');
      if (op) op.textContent = gbp(v.price); if (ow) { ow.hidden = !(v.compare_at_price > v.price); ow.textContent = gbp(v.compare_at_price || 0); } }
    var pay = bb.querySelector('[data-clv-pay]'); if (pay) pay.textContent = pay.getAttribute('data-clv-pay').replace('[amount]', gbp(Math.floor(price / 3)));
    var cs = document.querySelector('#sticky-product-form custom-selection .title-element');
    if (cs) cs.textContent = mode === 'bundle' ? 'All 3 flavours bundle' : (v ? v.title : cs.textContent);
    var sk = document.querySelector('#sticky-product-form button.add-to-cart');
    if (sk) { var mp = sk.querySelector('.money-p'), cp = sk.querySelector('.product-single__price--compare-at'), bt = sk.querySelector('.buy-btn-text');
      if (mp) mp.textContent = gbp(price); if (cp) { cp.textContent = was > price ? gbp(was) : ''; cp.hidden = !(was > price); }
      if (bt) bt.textContent = mode === 'bundle' ? 'Add all 3 -' : 'Add to Cart -'; }
  }
  function addTrio(id, b) {
    if (busy) return; busy = true; if (b) b.classList.add('is-loading');
    window.fetch(R + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { toast(j.description || j.message || 'Sorry, this item could not be added.'); }); })
      .catch(function () { toast('Sorry, something went wrong. Please try again.'); })
      .finally(function () { busy = false; if (b) b.classList.remove('is-loading'); });
  }
  document.addEventListener('change', function (e) {
    var i = e.target.closest && e.target.closest('[data-clv-buybox] input[type="radio"]'); if (!i) return;
    i.closest('[data-clv-buybox]').setAttribute('data-mode', i.value); syncBuy();
  });
  document.addEventListener('click', function (e) {
    if (buyMode() !== 'bundle') return;
    var sb = e.target.closest('#sticky-product-form button.add-to-cart, #sticky-product-form button[name="add"], #sticky-product-form [type="submit"]'); if (!sb) return;
    var tr = root.querySelector('[data-clv-buybox] input[value="bundle"]'); if (!tr) return;
    e.preventDefault(); e.stopImmediatePropagation(); addTrio(tr.getAttribute('data-trio'), sb);
  }, true);
  var lastImgFor = null;
  var FL = { raspberry: 'creatine-lv-raspberry', grapefruit: 'creatine-lv-grapefruit', unflavoured: 'creatine-lv-natural', natural: 'creatine-lv-natural' };
  function showSlide(im) {
    if (!im) return; var g = im.closest('[data-clv-gallery]'), i = im.getAttribute('data-clv-slide');
    im.removeAttribute('loading');
    $$('[data-clv-slide]', g).forEach(function (x) { x.classList.toggle('is-hidden', x !== im); });
    $$('[data-clv-thumb]', g).forEach(function (t) { var on = t.getAttribute('data-clv-thumb') === i; t.classList.toggle('is-on', on); t.setAttribute('aria-current', on); });
  }
  function syncImage(v) {
    if (!v) return; if (lastImgFor === null) { lastImgFor = v.id; return; } if (lastImgFor === v.id) return; lastImgFor = v.id;
    var im = null;
    if (v.featured_media) im = root.querySelector('[data-clv-media="' + v.featured_media.id + '"]');
    if (!im) { var t = (v.title || '').toLowerCase(), k = Object.keys(FL).filter(function (x) { return t.indexOf(x) > -1; })[0];
      if (k) im = root.querySelector('[data-clv-asset^="' + FL[k] + '"]'); }
    if (!im) return;
    im.removeAttribute('loading');
    if (im.complete && im.naturalWidth) showSlide(im); else { im.addEventListener('load', function () { if (lastImgFor === v.id) showSlide(im); }, { once: true }); }
  }
  function selectVariant(id) {
    var v = V.filter(function (x) { return String(x.id) === String(id); })[0]; if (!v) return;
    v.options.forEach(function (val, i) {
      var inp = $$('#variant_wrapper input[type="radio"]', ps).filter(function (r) { return r.value === val && (r.getAttribute('data-index') === 'option' + (i + 1) || !r.hasAttribute('data-index')); })[0];
      if (inp && !inp.checked) inp.click();
    });
    setTimeout(syncCards, 0);
  }
  function toast(msg) {
    var t = document.querySelector('[data-clv-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false; clearTimeout(toast.h); toast.h = setTimeout(function () { t.hidden = true; }, 3500);
  }
  var busy = false;
  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-clv-flavour]');
    if (f) { if (!f.disabled) selectVariant(f.getAttribute('data-clv-flavour')); return; }
    var b = e.target.closest('[data-clv-bundle]');
    if (b) {
      e.preventDefault(); if (b.disabled) return; addTrio(b.getAttribute('data-clv-bundle'), b); return;
    }
    var bu = e.target.closest('[data-clv-buy]');
    if (bu) {
      e.preventDefault(); if (bu.disabled) return;
      if (buyMode() === 'bundle') { var tr = root.querySelector('[data-clv-buybox] input[value="bundle"]'); if (tr) addTrio(tr.getAttribute('data-trio'), bu); return; }
      var nb0 = ps.querySelector('form[action*="/cart/add"] button[name="add"]'); if (nb0 && !nb0.disabled) nb0.click(); return;
    }
    var a = e.target.closest('[data-clv-atc]');
    if (a) {
      e.preventDefault();
      var nb = ps.querySelector('form[action*="/cart/add"] button[name="add"]');
      if (a.hasAttribute('data-clv-scrolltop') || !nb) { root.scrollIntoView({ behavior: 'smooth' }); return; }
      if (nb.disabled) { nb.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      nb.click(); return;
    }
    var th = e.target.closest('[data-clv-thumb]');
    if (th) {
      var g = th.closest('[data-clv-gallery]'), i = th.getAttribute('data-clv-thumb');
      $$('[data-clv-slide]', g).forEach(function (im) { im.classList.toggle('is-hidden', im.getAttribute('data-clv-slide') !== i); if (im.getAttribute('data-clv-slide') === i) im.removeAttribute('loading'); });
      $$('[data-clv-thumb]', g).forEach(function (t) { var on = t === th; t.classList.toggle('is-on', on); t.setAttribute('aria-current', on); });
      return;
    }
    var tab = e.target.closest('[data-clv-tab]');
    if (tab) {
      var s = tab.closest('[data-clv-tabs]'), k = tab.getAttribute('data-clv-tab');
      $$('[data-clv-tab]', s).forEach(function (t) { var on = t === tab; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; });
      $$('[data-clv-panel]', s).forEach(function (p) { p.hidden = p.getAttribute('data-clv-panel') !== k; });
      $$('.clv-dots span', s).forEach(function (d, j) { d.classList.toggle('is-on', String(j) === k); });
      return;
    }
    var nt = e.target.closest('[data-clv-ntab]');
    if (nt) {
      var box = nt.closest('.clv-acc__body'), key = nt.getAttribute('data-clv-ntab');
      $$('[data-clv-ntab]', box).forEach(function (t) { var on = t === nt; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on); });
      $$('[data-clv-npanel]', box).forEach(function (p) { p.hidden = p.getAttribute('data-clv-npanel') !== key; });
    }
  });
  ps.addEventListener('change', function () { setTimeout(syncCards, 0); });
  /* reveal cards on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.remove('is-pending'); io.unobserve(en.target); } else if (en.boundingClientRect.top > 0) { en.target.classList.add('is-pending'); } }); }, { rootMargin: '0px 0px -10% 0px' });
    $$('.clv-reveal').forEach(function (el) { io.observe(el); });
  }
  syncCards();
  window.addEventListener('load', function () { setTimeout(function () { $$('[data-clv-asset^="creatine-lv-raspberry"],[data-clv-asset^="creatine-lv-grapefruit"],[data-clv-asset^="creatine-lv-natural"],[data-clv-media]', root).forEach(function (im) { im.removeAttribute('loading'); }); }, 1500); });
})();

document.addEventListener('keydown',function(e){var t=e.target.closest&&e.target.closest('[data-clv-tab]');if(!t||(e.key!=='ArrowRight'&&e.key!=='ArrowLeft'))return;var l=[].slice.call(t.parentNode.querySelectorAll('[data-clv-tab]')),i=(l.indexOf(t)+(e.key==='ArrowRight'?1:l.length-1))%l.length;l[i].focus();l[i].click();e.preventDefault();});
